export const yupErrors = (err: unknown): string | undefined =>
  ((err as { errors?: string[] })?.errors || []).join("\n");
